import { z } from 'zod'
import { HotelSearchParamsSchema } from './query-params/hotel-query-params'

// NOTE: should move this to a common FE location
// can also be used to manage filters and sorting state for hotel results page
export const HotelResultsFormStateSchema = HotelSearchParamsSchema.pick({
  rooms: true,
  destination: true,
})
  .extend({
    searchString: z.string().optional(),
    startDateTime: z.date(),
    endDateTime: z.date(),
  })
  .refine((data) => data.startDateTime < data.endDateTime, {
    path: ['endDateTime'],
  })

export type HotelResultsFormState = z.infer<typeof HotelResultsFormStateSchema>
